// this is for dev palatte purposes ONLY 

const ColorPalette = () => {

    return (
        <div className="w-screen flex items-center justify-center">
            <div className="w-full flex-column ">
                <div className="w-1/3 h-20 bg-accent"></div>
                <div className="w-1/3 h-20 bg-white"></div>
                <div className="w-1/3 h-20 bg-base"> </div>
                <div className="w-1/3 h-20 bg-dark"> </div>
                <div className="w-1/3 h-20 bg-darker"> </div>
                <div className="w-1/3 h-20 bg-olive"> </div>
            </div>
        </div>
    )
};

export default ColorPalette;